/**
 * In this file use to contains the physician Module Vaccination screen UI and Logic
 **/
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { goBack } from "./../../../services/UtilsService";
import VaccinationModal from "./../../../shared/modals/VaccinationModal";
import ApiService from "./../../../services/ApiService";
import Pagination from "./../../../shared/components/Pagination";
import {
  convertDOBtoAge,
  convertDOBtoMonth,
  convertS3privateToPublic,
  convertIntToSuffix,
  findMissedVaccination,
} from "./../../../services/UtilsService";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

function Vaccination() {
  //Intial state declaraction
  const [modal, setModal] = useState({});
  const [vaccinationList, setVaccinationList] = useState([]);
  const [param, setParam] = useState({ page: 0, limit: 10 });
  const [misstedVaccinaction, setMisstedVaccinaction] = useState([]);
  const masterVaccination = useSelector((state) => state?.vaccination);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();
  const currentLang = localStorage.getItem('i18nextLng');

  /**
   * To handle pagination event
   * @data pass the page Number
   **/
  const handlePaginate = (data) => {
    setParam({ ...param, page: data });
  };
  //item.dose,item.vaccination,convertDOBtoMonth(item.dob),item.dob
  /**
   * To fint Next vaccinaction List details for particular Member profile
   * @dose pass the latest having dose Number
   * @vaccine pass the latest having Vaccination master id
   * @memberAge pass the member age
   **/
  const findNextVaccinationName = (dose, vaccine, memberAge) => {
    var vaccinactionList;
    if (
      masterVaccination &&
      masterVaccination?.vaccinationName &&
      masterVaccination?.vaccinationAge
    ) {
      // eslint-disable-next-line
      masterVaccination &&
        masterVaccination.length !== 0 &&
        masterVaccination?.vaccinationAge.map((age) => {
          // eslint-disable-next-line
          masterVaccination &&
            masterVaccination.length !== 0 &&
            masterVaccination?.vaccinationName.map((name) => {
              var result = masterVaccination?.mapping.filter(
                (i) => i.age === age.id && i.vaccination === name.id
              );
              if (result.length !== 0 && result[0].span !== 0) {
                var colList = masterVaccination?.mapping.filter(
                  (i) =>
                    i.vaccineId === result[0].vaccineId &&
                    i.vaccination === name.id
                );
                const mergedData1 = [
                  {
                    age: [...new Set(colList.map((obj) => obj.age))],
                    //dose: [...new Set(colList.map(obj => obj.dose))],
                    dose: colList.map((obj) => obj.dose),
                    vaccination: colList[0].vaccination,
                    type: [...new Set(colList.map((obj) => obj.type))],
                  },
                ];
                // eslint-disable-next-line
                mergedData1.map((a, i) => {
                  var months;
                  if (age.name === "Birth") {
                    months = "0-0";
                  } else {
                    var integer = age.name
                      .replace(/years?|months|weeks?/g, "")
                      .trim();
                    if (age.name.includes("years")) {
                      var arr = integer.split("-");
                      months =
                        parseInt(arr[0]) * 12 + "-" + parseInt(arr[1]) * 12;
                    } else if (age.name.includes("months")) {
                      if (integer.split("-").length === 1) {
                        months = integer + "-" + integer;
                      } else {
                        months = integer;
                      }
                    } else {
                      var weeks = Math.round(parseInt(integer) / 4.34524);
                      months = weeks + "-" + weeks;
                    }
                  }
                  var period = months.split("-");
                  if (
                    (memberAge < parseInt(period[0]) &&
                      memberAge > parseInt(period[1])) ||
                    (memberAge < parseInt(period[0]) &&
                      memberAge < parseInt(period[1]))
                  ) {
                    if (!vaccinactionList) {
                      var typeValue =
                        a.type && a.type[i] !== 0
                          ? masterVaccination?.vaccinationType.find(
                              (item) => item.id === a.type[i]
                            )
                          : null;
                      vaccinactionList = (
                        <span>
                          {currentLang === 'ta' ? name.name_tamil : name.name} -{" "}
                          {typeValue && typeValue !== null ? (
                            <span>{currentLang === 'ta' ? typeValue?.name_tamil : typeValue?.name}</span>
                          ) : null}
                          {a.dose[0] > 4 ? a.dose[0] - 4 : a.dose[0]}
                          <sup>{convertIntToSuffix(a.dose[0])}</sup>
                          {a.dose[0] > 4 ? ` ${t('modal.booster')}` : ` ${t('common.dose')}`}
                        </span>
                      );
                    }
                  }
                });
              }
            });
        });
      return vaccinactionList;
    }
  };

  /**
   * To handle pagination event
   * @masterVaccination pass the master Vaccination details
   * @id pass the Member id
   * @age pass the Member age
   **/
  const handleMissedVaccinaction = async (masterVaccination, id, age) => {
    await findMissedVaccination(masterVaccination, id, age, currentLang, t).then(
      async (list) => {
        if (list) {
          await setMisstedVaccinaction(list);
        }
      }
    );
  };

  //callback function
  const handleClose = () => setModal({});

  /**
   * handeonChange while search
   * @e we get the event details from the change action
   **/
  const handleChange = async (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setParam({ ...param, [name]: value, page: 0 });
  };

  /**
   * handeonChange while dropdown change
   * @e we get the event details from the click action
   **/
  const handleSortChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setParam({ ...param, [name]: value });
  };

  //Component Initialize function
  useEffect(() => {
	const fetchData = async () => {
		setIsLoading(true); 
		try {
		  const response = await ApiService.listVaccinationMember(param);
		  if (response.status === 200) {
			  if(param.sort === 'missed'){
				const sortedProcessedData = response.data.processedData.sort((a, b) => {
					if(a.missedVaccinationData.smallestMissedVaccination.daysMissed === b.missedVaccinationData.smallestMissedVaccination.daysMissed){
						return b.missedVaccinationData.smallestMissedVaccination.vaccination  - a.missedVaccinationData.smallestMissedVaccination.vaccination ;
					}else{
						return b.missedVaccinationData.smallestMissedVaccination.daysMissed  - a.missedVaccinationData.smallestMissedVaccination.daysMissed ;
					}
				});
				setVaccinationList({ ...response.data, processedData: sortedProcessedData });  
			  }else{
				setVaccinationList(response.data);  
			  }			
		  }
		}catch (error) {
			console.error('Error fetching member vaccination data:', error);
		} finally {
			setIsLoading(false); 
		}
	};
	fetchData();
    
  }, [param]);

  return (
    <>
      <main id="main" className="main">
        {/*import VaccinationModal*/}
        {Object.keys(modal).length !== 0 && (
          <VaccinationModal data={modal} handleClose={handleClose} />
        )}
        <div className="pagetitle clearfix">
          <div className="float-start">
            <h1>{t('sidebar.vaccination')}</h1>
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/physician/dashboard">
                    {t('sidebar.home')}
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  {t('sidebar.vaccination')}
                </li>
              </ol>
            </nav>
          </div>
          <div className="float-end mt-2 me-1">
            <span onClick={goBack} className="backIcon">
              <i className="iconly-Bold-ArrowLeftSquare"></i>
            </span>
          </div>
        </div>
        {/*Page Content Section*/}
        <section className="pagesection">
          {/*Search*/}
          <div className="row my-3">
            <div className="col-xxl-7 col-lg-7 d-flex">
              <div className="input-group input-group-sm me-2 w-50">
                <input
                  type="text"
                  name="search"
                  value={param.search ? param.search : ""}
                  onChange={handleChange}
                  className="form-control"
                  placeholder={t('common.search')}
                />
                <button className="btn btn-tmBlue" type="button">
                  <i className="ri-search-line align-middle" />
                </button>
              </div>
            </div>
            <div className="col-xxl-5 col-lg-5">
              <div className="dropdown float-end me-3">
                <a
                  className="btn btn-sm btn-outline-tmBlue dropdown-toggle"
                  href="javascript;"
                  role="button"
                  id="dropdownMenuLink"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {" "}
                  {t('common.sort')}{" "}
                </a>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuLink"
                >
                  <li>
                    <button
                      className={
                        param.sort === "added"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      type="button"
                      value="added"
                      name="sort"
                      onClick={handleSortChange}
                    >
                      {" "}
                      {t('common.recentAdded')}{" "}
                    </button>
                  </li>
                  <li>
                    <button
                      className={
                        param.sort === "updated"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      type="button"
                      value="updated"
                      name="sort"
                      onClick={handleSortChange}
                    >
                      {" "}
                      {t('common.recentUpdated')}{" "}
                    </button>
                  </li>
                  <li>
                    <button
                      className={
                        param.sort === "missed"
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      type="button"
                      value="missed"
                      name="sort"
                      onClick={handleSortChange}
                    >
                      {" "}
                      {t('common.missedVaccination')}{" "}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/*End Search*/}
          {/*Table*/}
          <div className="row my-3">
            <div className="col-xxl-12">
              <div className="table-responsive">
                <table className="table table-borderless theme-table">
                  <thead>
                    <tr>
                      <th width={250}>
                        {t('table.memberDetails')}
                      </th>
                      <th>{t('table.lastVaccination')}</th>
                      <th>{t('table.nextVaccination')}</th>
                      <th className="text-center">
                        {t('table.missedVaccination')}
                      </th>
                      <th width={200} className="text-center">
                        {t('table.vaccinationChart')}
                      </th>
					  <th className="text-center">
                        {t('table.add')}
                      </th>
                    </tr>
                  </thead>
                  {vaccinationList && vaccinationList?.processedData?.length ? (
                    <tbody>
                      {vaccinationList.processedData.map((item, i) => (
                        <tr
                          key={i}
                          className={item?.gender === 0 ? "male" : "female"}
                        >
                          <td>
                            <div className="d-flex align-items-center ps-1">
                              <div className="avtar-img">
                                <span className="rounded-circle">
                                  {item?.photo === "default.png" ? (
                                    <img
                                      src="/assets/img/user-avatar.png"
                                      alt="UN"
                                    />
                                  ) : (
                                    <img
                                      src={convertS3privateToPublic(
                                        item?.photo
                                      )}
                                      alt="UN"
                                    />
                                  )}
                                </span>
                              </div>
                              <div className="ms-3">
                                <Link
                                  to={
                                    "/physician/member-profile/" + item?.member
                                  }
                                >
                                  <h5 className="table-title fw-bold text-capitalize">
                                    {item?.name}
                                  </h5>
                                </Link>
                                <p className="table-subtitle">
                                  <span>
                                    {item.gender === 0 ? t('common.boy') :  t('common.girl')}
                                  </span>{" "}
                                  - {convertDOBtoAge(item.dob, t)}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td className="tecx-capitalize text-tmGreen">
                            {/* {item?.lastVaccination} - {item?.type_name} */}
                            {
                              // Get matching vaccination name
                              (() => {
                                const vac = masterVaccination?.vaccinationName.find(v => v.id === item.vaccination);
                                return currentLang === 'ta' ? vac?.name_tamil : vac?.name;
                              })()
                            }
                            {" - "}
                            {
                              // Get matching type name
                              (() => {
                                const type = masterVaccination?.vaccinationType.find(t => t.id === item.type && t.vaccineId === item.vaccination);
                                return type ? (currentLang === 'ta' ? type?.name_tamil : type?.name) : "";
                              })()
                            }
                            {item.dose !== 0 ? (
                              <span>
                                {" " + item.dose > 4
                                  ? item.dose - 4
                                  : item.dose}
                                <sup>{convertIntToSuffix(item?.dose)}</sup>
                                {item.dose > 4 ? `${t('modal.booster')}` : `${t('common.dose')}`}
                                <br />
                              </span>
                            ) : (
                              ` - ${t('common.birth')}`
                            )}
                            {/*<span>{' '+item.dose}<sup>{convertIntToSuffix(item?.dose)}</sup> Dose<br /></span>*/}
                          </td>
                          <td className="tecx-capitalize text-tmOrange">
                            {findNextVaccinationName(
                              item.dose,
                              item.vaccination,
                              convertDOBtoMonth(item.dob)
                            )
                              ? findNextVaccinationName(
                                  item.dose,
                                  item.vaccination,
                                  convertDOBtoMonth(item.dob)
                                )
                              : "--"}
                          </td>
                          <td className="text-center">
                            {" "}
                            <OverlayTrigger
                              trigger={["focus"]}
                              placement="right"
                              overlay={
                                <Popover
                                  id="popover-basic"
                                  title="Missed Vaccination:"
                                >
                                  <h3 className="popover-header ng-star-inserted text-capitalize">
                                    {item?.name}{t('common.possessive_suffix')} {t('common.missedVaccination')}:
                                  </h3>
                                  <div
                                    className="popover-body"
                                    style={{
                                      display: "inline-grid",
                                      maxHeight: "250px",
                                      overflow: "auto",
                                    }}
                                  >
                                    {misstedVaccinaction &&
                                    misstedVaccinaction.length ? (
                                      misstedVaccinaction.map((item, i) => (
                                        <label
                                          key={i}
                                          className="col tecx-capitalize text-danger"
                                        >
                                          <i className="fa-solid fa-circle-xmark"></i>{" "}
                                          {item}
                                        </label>
                                      ))
                                    ) : (
                                      <label
                                        key={i}
                                        className="col text-capitalize text-success"
                                      >
                                        {t('common.noMissed')}
                                      </label>
                                    )}
                                  </div>
                                </Popover>
                              }
                            >
                              <button style={{ background: "transparent", border: "none" }}>
                                <label htmlFor={`vaccination${i}`}>
                                  <input
                                    name={`vaccination${i}`}
                                    id={`vaccination${i}`}
                                    className="inputfile"
                                    style={{
                                      visibility: "visible",
                                      width: "1px",
                                    }}
                                  />
                                  <span>
                                    <i
                                      style={{
                                        color: "red",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        handleMissedVaccinaction(
                                          masterVaccination,
                                          item.member,
                                          convertDOBtoMonth(item.dob)
                                        )
                                      }
                                      className="fa-solid fa-syringe"
                                    ></i>
                                  </span>
                                </label>
                              </button>
                            </OverlayTrigger>
                          </td>
                          <td className="text-center">
                            <Link
                              onClick={() => {
                                setModal({
                                  vaccination: true,
                                  member: item.member,
                                  dob: convertDOBtoMonth(item.dob),
                                  name: item.name,
                                  parent: item.parent,
                                });
                              }}
                              className="table-link text-tmBlue"
                            >
                              {" "}
                              <i className="fa-solid fa-syringe" />
                            </Link>
                          </td>
						  <td className="text-center">
						<Link to={'/physician/add-vaccination/'+item.member} className="table-link text-tmBlue">
							<i className="ri-add-box-fill align-middle fw-normal"></i> </Link> 
						</td>
                        </tr>
                      ))}
                    </tbody>
                  ) : ( !isLoading && 
                    <tbody>
                      <tr>
                        <td colSpan="11" className="text-center">
                          {t('common.noRecord')}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
          {/*End Table*/}
          {/*Pagination*/}
          {vaccinationList &&
            vaccinationList.length !== 0 &&
            vaccinationList?.data?.length !== 0 && (
              <div className="row my-3">
                <div className="col-xxl-12 d-flex justify-content-center">
                  <Pagination
                    page={param.page}
                    handlePaginate={handlePaginate}
                    total={vaccinationList.count}
                  />
                </div>
              </div>
            )}
          {/*End Pagination*/}
        </section>
        {/*End Page Content Section*/}
      </main>
    </>
  );
}

export default Vaccination;
